<script>
  import {
    GridWrap,
    GridWrapModifier,
    GridColumn,
    GridColumnModifier,
  } from '$lib/components/grid';

  import {
    serviceProviderService,
    mostRecentServiceProvider,
  } from '$lib/stores/service-providers';
  import {hasFields} from '$lib/utils/entities';

  const year = new Date().getFullYear();

  $: serviceProviders = $serviceProviderService.context.items;
  $: serviceProvider =
    $mostRecentServiceProvider || serviceProviders.find(Boolean);
  $: menuItems = serviceProvider
    ? serviceProvider.fields.footerMenu.filter(hasFields) || []
    : [];
</script>

<footer>
  <hr class="u-fc--base-ltst u-margin--larger--block-end" />

  <GridWrap modifiers={[GridWrapModifier.Reverse]}>
    {#if serviceProvider}
      <GridColumn
        baseWidth="1-of-1"
        modifiers={[
          GridColumnModifier.ShrinkWrapLapAndUp,
          GridColumnModifier.ShrinkWrapPrint,
        ]}
      >
        <p>
          <img
            src={serviceProvider.fields.logo.fields.file.url}
            alt={serviceProvider.fields.logo.fields.title}
          />
        </p>
      </GridColumn>
    {/if}

    <GridColumn modifiers={[GridColumnModifier.Auto]}>
      <div class="u-margin--block-end">
        {#if serviceProvider}
          <div class="u-fs--base u-fc--base-dk">
            <strong>
              {serviceProvider.fields.title}
            </strong>
          </div>
        {/if}

        <GridWrap modifiers={[GridWrapModifier.NoGutter]}>
          <GridColumn modifiers={[GridColumnModifier.ShrinkWrap]}>
            Powered by Cillar&nbsp;
          </GridColumn>
          <GridColumn modifiers={[GridColumnModifier.ShrinkWrap]}>
            &copy;&nbsp;{year}
          </GridColumn>
        </GridWrap>
      </div>
    </GridColumn>
  </GridWrap>

  <div>
    {#each menuItems as menuItem, index}
      <a
        href={`/${menuItem.fields.slug}--${menuItem.sys.id}`}
        data-sveltekit-prefetch
      >
        {menuItem.fields.title}
      </a>
      {#if index < menuItems.length - 1}|{' '}{/if}
    {/each}
  </div>
</footer>
